import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSocketio from 'vue-socket.io'
import VueCookies from "vue-cookies";
import VueSweetalert2 from "vue-sweetalert2";


Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueCookies);
Vue.use(VueSweetalert2);
Vue.use(
  new VueSocketio({
    debug: true,
    connection: process.env.VUE_APP_API_SOCKET,
  })
)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
